var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTelegram = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.43202 11.8734C8.93026 10.3492 11.263 9.34443 12.4302 8.85896C15.7627 7.47285 16.4551 7.23207 16.9065 7.22411C17.0058 7.22237 17.2277 7.24697 17.3715 7.36363C17.4929 7.46214 17.5263 7.59521 17.5423 7.6886C17.5583 7.782 17.5782 7.99476 17.5623 8.161C17.3818 10.0585 16.6003 14.6632 16.2028 16.7884C16.0346 17.6876 15.7034 17.9892 15.3827 18.0187C14.6859 18.0828 14.1567 17.5581 13.4817 17.1157C12.4256 16.4234 11.8289 15.9924 10.8037 15.3168C9.61896 14.5361 10.387 14.107 11.0622 13.4057C11.2389 13.2221 14.3093 10.4294 14.3687 10.176C14.3762 10.1443 14.3831 10.0262 14.3129 9.96388C14.2427 9.90151 14.1392 9.92284 14.0644 9.9398C13.9585 9.96384 12.2713 11.079 9.00276 13.2854C8.52385 13.6142 8.09007 13.7745 7.70141 13.7661C7.27295 13.7568 6.44876 13.5238 5.83606 13.3246C5.08456 13.0804 4.48728 12.9512 4.53929 12.5363C4.56638 12.3202 4.86395 12.0993 5.43202 11.8734Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTelegram);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/telegram.78eef5a386d7a1ab0ae87a45657f1b97.svg";